import { List, ListItem } from 'foundations-components/transitional/components/List';
import { SKELETON_TITLE_TOTAL_HEIGHT, SKELETON_VALUE_TOTAL_HEIGHT, SkeletonLabel, SkeletonValue } from './PropertySkeleton';
import { Flex } from 'foundations-components/components/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ITEM_MARGIN_HEIGHT = 16; // keep in sync with marginBlockStart

export function getTextListSkeletonHeight(loadingComponentProps) {
  const {
    count
  } = loadingComponentProps;
  const ht = count * (SKELETON_TITLE_TOTAL_HEIGHT + SKELETON_VALUE_TOTAL_HEIGHT) + (count - 1) * ITEM_MARGIN_HEIGHT;
  return ht;
}
const TextListSkeleton = ({
  cardId,
  count
}) => {
  const skeletons = Array.from({
    length: count
  });
  return /*#__PURE__*/_jsx(List, {
    "data-loading": true,
    "data-test-id": "property-input-skeleton",
    styled: false,
    role: "status",
    children: skeletons.map((__, index) => /*#__PURE__*/_jsx(ListItem, {
      children: /*#__PURE__*/_jsxs(Flex, {
        flexDirection: "column",
        marginBlockStart: index === 0 ? '0' : '400' /* keep in sync with ITEM_MARGIN_HEIGHT */,
        children: [/*#__PURE__*/_jsx(SkeletonLabel, {}), /*#__PURE__*/_jsx(SkeletonValue, {})]
      })
    }, `${cardId}-${index}`))
  });
};
export default TextListSkeleton;